import moment from 'moment';
import { IMAGE_BASE_NAME_FORMAT, INTERVAL_IMAGES, MAX_DATE_INTERVAL, MIN_DATE } from '../config';
import { redodnearHora } from './redondearHora';

export const generaListadoImagenes = () => {
    let retorno = [];

    let fechaHoraActual = redodnearHora(MIN_DATE)
    const fechaLimite = fechaHoraActual.clone().subtract(...MAX_DATE_INTERVAL);
    while (fechaHoraActual.diff(fechaLimite) > 0) {
        let aux = fechaHoraActual.utc().format(IMAGE_BASE_NAME_FORMAT);
        fechaHoraActual.subtract(...INTERVAL_IMAGES);
        retorno.push(aux);
    }

    return retorno;
};
